
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface MobileNavigationProps {
  isOpen: boolean;
  onClose: () => void;
  isAuthenticated: boolean;
}

const MobileNavigation = ({ isOpen, onClose, isAuthenticated }: MobileNavigationProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/95 z-50 overflow-y-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex justify-between items-center mb-8">
          <Link to="/" className="text-2xl font-bold text-gaming-blue">
            BattleforgePC
          </Link>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="h-6 w-6" />
          </Button>
        </div>

        <nav className="space-y-6">
          <div className="space-y-2">
            <h3 className="text-lg font-medium text-gaming-blue mb-2">Gaming PCs</h3>
            <Link
              to="/gaming-pcs"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Configured Gaming PCs
            </Link>
            <Link
              to="/customize"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Custom Gaming PCs
            </Link>
            <Link
              to="/accessories"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Accessories
            </Link>
          </div>

          <div className="space-y-2">
            <h3 className="text-lg font-medium text-gaming-blue mb-2">Workstations</h3>
            <Link
              to="/workstations"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Professional Workstations
            </Link>
          </div>

          <div className="space-y-2">
            <h3 className="text-lg font-medium text-gaming-blue mb-2">Components</h3>
            <Link
              to="/components"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              PC Components
            </Link>
            <Link
              to="/marketplace"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Marketplace
            </Link>
          </div>

          <div className="space-y-2">
            <Link
              to="/support"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Support
            </Link>
            <Link
              to="/articles"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Articles
            </Link>
            <a
              href="https://www.trustpilot.com/review/battleforgepc.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Reviews
            </a>
            <Link
              to="/order-tracking"
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              Track Order
            </Link>
            <Link
              to={isAuthenticated ? "/account" : "/auth"}
              className="block py-2 border-b border-gaming-dark/20"
              onClick={onClose}
            >
              {isAuthenticated ? "Account" : "Sign In"}
            </Link>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileNavigation;
